export default "__VITE_ASSET__cc7eb7bd__"